import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const LostNonWarrantyComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="紛失・保証外レンズ申込完了" content="紛失・保証外レンズ申込が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default LostNonWarrantyComplete;